import React from 'react';
import { useMsal } from '@azure/msal-react';
import './EndSession.scss';

export const EndSession: React.FC = () => {
    const { instance } = useMsal();

    const handleLoginAgain = () => {
        instance.logout();
    };

    return (
        <div className="end-session-page">
            <div className="end-session-box">
                <div className="company-logo">
                    <img 
                        data-tenant-branding-logo="true"
                        src="/images/Logo.svg"
                        alt="Company Logo"
                    />
                </div>
                
                <div className="session-title">
                    Session Ended
                </div>
                
                <p className="session-description">
                    Session has been ended because another user has logged in with the same credentials. Please log in again to continue.
                </p>
                
                <div className="button-container">
                    <button
                        onClick={handleLoginAgain}
                        className="signin-button"
                    >
                        Go to Sign In
                    </button>
                </div>
            </div>
            
            <div className="end-session-footer">
                <div>
                    ©Copyright Stradix Technologies, Inc. Austin, TX. All rights reserved.
                </div>
            </div>
        </div>
    );
};

